<template>
  <div class="bg-white rounded mt-6 py-3 px-4 leading-normal">
    <div class="w-full flex flex-col md:flex-row border-b py-5 mb-6">
      <div
        class="w-32 h-32 p-4 -mt-20 ml-2 mb-2 text-white rounded-lg relative flex-no-shrink bg-primary mr-5" >
        <icon name="pdf"></icon>
      </div>
      <div class="mb-4">
        <h1 class="text-xl my-3 font-medium">Report History</h1>
      </div>
    </div>

    <loader v-if="reports === null" />
    <div v-else>
      <panel v-if="reports.data.length === 0" class="pt-6">
        <div>
          <i class="fas fa-info-circle"></i> No valuation reports have been created.
        </div>
      </panel>
      <panel v-else class="pt-6 text-sm">
        <div class="overflow-x-auto">
          <table class="table-auto text-center w-full">
            <thead class="uppercase text-xs">
              <tr class="whitespace-no-wrap">
                <th class="text-left p-2">ID</th>
                <th class="p-2">LeadPro Lead ID</th>
                <th class="p-2">Address</th>
                <th class="p-2">Valuation</th>
                <th class="p-2">Created At</th>
                <th class="p-2">Download</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="report in reports.data" :key="report.id">
                <td class="text-left p-2">{{ report.id }}</td>
                <td class="p-2">{{ report.leadpro_entry_id }}</td>
                <td class="p-2">{{ report.address }}</td>
                <td class="p-2">{{ report.formatted_valuations['average'] }}</td>
                <td class="p-2">{{ report.created_at | date }}</td>
                <td class="p-2">
                  <a v-if="report.pdf_url" :href="report.pdf_url" target="_blank" class="text-grey-darkest hover:text-blue-dark">
                    <i class="fas fa-fw fa-download"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>

          <paginator :data="reports" @change="searchParams.page = $event"/>
        </div>
      </panel>
    </div>
  </div>
</template>
<script>
import { v2Api } from '@/http'
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
import Loader from '../../components/Loader.vue'
export default {
  components: { Loader },
  data () {
    return {
      loading: true,
      reports: null,
      searchParams: {
        q: null,
        page: 1
      }
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  created () {
    this.search()
  },
  methods: {
    ...mapActions(['setPageLoading']),
    search: debounce(function () {
      this.setPageLoading(true)
      v2Api.get('valuation-reports', {
        params: {
          office_id: this.selectedOffice.id,
          ...this.searchParams
        }
      }).then(response => {
        this.reports = response.data
        this.setPageLoading(false)
      })
    }, 500),
    pageChanged (page) {
      this.searchParams.page = page
    }
  },
  watch: {
    selectedOffice: {
      handler () {
        this.search()
      },
      deep: true
    },
    searchParams: {
      handler () {
        this.search()
      },
      deep: true
    }
  }
}
</script>
